import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpUtilService } from './http-util.service';
import { environment } from '../../environments/environment';

export class ChangeEntry {
  content?: string;
}

export class ChangeLog {
  title?: string;
  items?: ChangeEntry[];
}

@Injectable({
  providedIn: 'root'
})
export class ChangeLogService {
  /**Log of change updates*/
  pageSize = 10;
  private _updates;
  constructor (private http: HttpUtilService) { }

  /**
   * Get change updates by page
   * @param page Page number
   */
  getChanges (page: number): Observable<any> {
    let changePage = new Subject();
    this.http.request('GET', environment.apiRoot + '/changes', {}, null, true).subscribe(changes => {
      this._updates = changes;
      changePage.next( this.paginate(changes, this.pageSize, page));
    }
    );
    return changePage.asObservable();
  }

  /**
   * Paginate and array
   * @param array array to paginate
   * @param page_size number per page
   * @param page_number page to get
   */
  paginate(array: any[], page_size: number, page_number: number): any[] {
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return array.slice((page_number - 1) * page_size, page_number * page_size);
  }
}
